import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import './style.scss';
// import PPIService from "../../service/sfp/ppi-service"
import { getRecalculeScenarios } from '../../service/sfp/politique-services'



export default class Politique extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            slected: '',
            selectedID: null,
            objectifInput: '',
            objectifOutput: '',
            recalculateResultatAnnue: null,
            recalculateCafBrut: null,
            loading: false,
            inputSubItem: [],
            outputSubItem: [],
            resultatAnnuel: 0,
            totalDesRecettes: 0,
            totalDesDépenses: 0,
            cafBurt: 0,
            effortAFournirInput: 0,
            effortAFournirOutput: 0,
            resteParentInput: null,
            resteParentOutput: null,
            ObjectifInput: {},
            ObjectifOutput: {},
            resteOutput: {},
            resteInput: {},
            ppiID: null,
            laID: null,
            localshow: true,
            error: '',
            errorShow: false,
            errorOutput: '',
            subInput: {},
            subErrorIn: '',
            subErrorOut: '',
            subOutput: {},
            objectifOutputError: '',
            objectifInputError: '',
        }
    }
    

    componentDidUpdate(prevProp) {

        /*calculation when we select any SCÉNARIO DE FONCTIONNEMENT*/

        let localAuthority = this.props.localAuthority
        let ComingScenarios = this.props.selectedScenarios[new Date().getFullYear()]
        if ((localAuthority && this.state.localshow)) {
            this.setState({ localshow: false,laID: localAuthority.id })
            // PPIService.findPPIByLAId(localAuthority.id)
            //     .then(res => this.setState({ ppiID: res.id, laID: localAuthority.id }))
        }
       
        if (ComingScenarios && prevProp.selectedScenarios !== this.props.selectedScenarios) {
            let scenario = this.props.scenarios && this.state.slected && this.props.scenarios.filter(r => r.description == this.state.slected) 
            this.setState({ totalDesRecettes: Math.round(ComingScenarios.totalRecettes), totalDesDépenses: Math.round(ComingScenarios.totalDepenses), cafBurt: Math.round(ComingScenarios.cafBrut), resultatAnnuel: Math.round(ComingScenarios.resultatAnnuel) }, () => {
                this.calculateEffortAFournirInput(this.state.objectifInput, this.state.totalDesRecettes,"back")
                this.calculateEffortAFournirOutput(this.state.objectifOutput, this.state.totalDesDépenses)
                if(scenario[0].arbitrage !== null){
                    let outputSubItem=[]
                    let inputSubItem=[]
                    let ObjectifInput={}
                    let ObjectifOutput={}
                    let subInput={}
                    let subOutput={}
                    let effortAFournirInput= 0
                    let effortAFournirOutput= 0
                    let objectifInput = ''
                    let objectifOutput = ''
                    let resteOutput= {}
                    let resteInput= {}
                    scenario[0].arbitrage.arbitragePoliticalApproaches.map(res=>{
                       if(res.recettesValue){
                        let key = res.politicalApproach.id
                        ObjectifInput={...ObjectifInput,[key]:res.recettesValue}
                        res.servicePoliticalApproaches.map(r=>{
                        if(r.recettesValue){
                            let keys = r.service.id
                            subInput={...subInput,[key]:{...subInput[key],[keys]:r.recettesValue}}
                            inputSubItem.push(res.politicalApproach.id)
                        }       
                        })
                       }
                    })
                    scenario[0].arbitrage.arbitragePoliticalApproaches.map(res=>{
                        if(res.depensesValue){
                         let key = res.politicalApproach.id
                         ObjectifOutput={...ObjectifInput,[key]:res.depensesValue}
                         res.servicePoliticalApproaches.map(r=>{
                         if(r.depensesValue){
                             let keys = r.service.id
                             subOutput={...subOutput,[key]:{...subOutput[key],[keys]:r.depensesValue}}
                             outputSubItem.push(res.politicalApproach.id)
                         }                  
                         })
                        }
                     })
    
                    if(ObjectifInput){
                        let updatedValue = 0
                        for (const v in ObjectifInput) {
                            updatedValue = updatedValue + parseInt(ObjectifInput[v] ? ObjectifInput[v] : 0)
                        }
                        effortAFournirInput= updatedValue
                        let input = updatedValue + this.state.totalDesRecettes
                        objectifInput = input.toString()
                    }
                    if(ObjectifOutput){
                        let updatedValue = 0
                        for (const v in ObjectifOutput) {
                            updatedValue = updatedValue + parseInt(ObjectifOutput[v] ? ObjectifOutput[v] : 0)
                        }
                        effortAFournirOutput= updatedValue
                        let output = updatedValue + this.state.totalDesDépenses
                        objectifOutput = output.toString()
                    }

                    if(inputSubItem.length){
                        inputSubItem.map(res=>{
                            resteInput={...resteInput,[res]:0}
                        })
                    }

                    if(outputSubItem.length){
                        outputSubItem.map(res=>{
                            resteOutput={...resteOutput,[res]:0}
                        })
                    }

                    this.setState({outputSubItem,inputSubItem,ObjectifInput,ObjectifOutput,subInput,subOutput,
                        effortAFournirInput,effortAFournirOutput,objectifInput,objectifOutput ,resteParentInput: 0,
                        resteParentOutput:0,resteInput,resteOutput})
                }

            })
        }

    }

    render() {
        let state = this.state
        let props = this.props
        let approches = props.localAuthority && props.localAuthority.approaches ? props.localAuthority.approaches : []
        let scenario = props.scenarios && state.slected ? props.scenarios.filter(r => r.description !== state.slected) : props.scenarios
        let scenarioId = props.scenarios && state.slected && props.scenarios.filter(r => r.description == state.slected) 


        return (
            <div className="field">
                <hr style={{ border: '1px solid black' }} />
                <label className="label">ÉQUILIBRAGE DU SCÉNARIO DE FONCTIONNEMENT</label><br />
                <div style={{ width: "30%" }}>
                    {props.loadingCurrentLocalAuthority || props.loadingScenarios ?
                        <div className="field" >
                            <div className="control is-loading">
                                <input className="input is-static" readOnly value="Chargement des services..." />
                            </div></div> : props.loadingSlectedScenario ?
                            <div className="field" >
                                <div className="control is-loading">
                                    <input className="input is-static" readOnly value={state.slected} />
                                </div></div> :
                            <div className="select is-fullwidth is-narrow">
                                <select defaultValue={state.slected} onChange={(e) => this.selectedScenario(e)}>
                                    <option value="Non défini">Choisir un scénario de fonctionnement</option>
                                    {state.slected && <option >{state.slected}</option>}
                                    {scenario.map(res => <option key={res.id} value={`${res.description},${res.id}`}>{res.description}</option>)}
                                </select>
                            </div>}
                </div>
             
                {state.slected && !props.loadingSlectedScenario &&
                    [<div className="upperArea">
                    <span><b>Résultat de I'année: {this.space(state.resultatAnnuel)} €</b><i className='recalculate'>{state.recalculateResultatAnnue && `(recalculé:${this.space(state.recalculateResultatAnnue)} €)`}</i></span><br />
                    <span><b>CAF BRUT: {this.space(state.cafBurt)} €</b><i className='recalculate'>{state.recalculateCafBrut && `(recalculé: ${this.space(state.recalculateCafBrut)} €)`}</i></span>
                    </div>,
                    <table className="customers">
                        <tbody>
                            <tr>
                                <td className='sidewidth'>
                                    <b>Total des recettes: {this.space(state.totalDesRecettes)} €</b><br />
                                    {state.objectifInputError  && <p>{state.objectifInputError}</p>}
                                    <span><b>Objectif:</b>
                                        <input className='inputmargin' value={this.inputss(state.objectifInput)} onChange={(e) => this.onChangeObjectifInput(e)} />
                 Effort a fournir : {`${this.space(state.effortAFournirInput)} €`}
                                    </span>
                                </td>
                                <td className='sidewidth'>
                                    <b>Total des dépenses: {this.space(state.totalDesDépenses)} €</b><br />
                                    {state.objectifOutputError && <p>{state.objectifOutputError}</p>}
                                    <span><b>Objectif:</b>
                                        <input className='inputmargin' value={this.inputss(state.objectifOutput)} onChange={(e) => this.onChangeObjectifOutput(e)} />
                 Effort a fournir : {`${this.space(state.effortAFournirOutput)} €`}
                                    </span>
                                </td>
                            </tr>
                            {approches.length > 0 && state.objectifInput && state.objectifOutput && parseInt(state.objectifInput) > 0 && parseInt(state.objectifOutput) > 0 &&
                                <tr>
                                    <td className='sidewidth'>
                                        <b>Repartition des efforts:</b><br />
                                        <span style={state.resteParentInput > 0 ? { color: "red" } : { color: "green" }}>Reste:{`${this.space(state.resteParentInput)} €`}</span><br />
                                        {state.subErrorIn  && <span style={{ color: "red" }}>{state.subErrorIn}</span>}
                                        {state.error && state.errorShow && <span style={{ color: "red" }}>{state.error}</span>}
                                        {approches.map((res, i) =>
                                            <div className='objectifi' key={i}>
                                                <div className='inline'>
                                                    <b style={{width:'9rem'}}>{res.name}:</b>
                                                <input name={res.id} className='inputmargin' value={this.inputss(this.state.ObjectifInput[res.id])} onChange={(e) => this.claculateServiceInput(e)} />
                                                <p style={{width:'10rem'}}>
                                                    { state.resteInput[res.id] > 0 && <span style={{ color: "red" }}>Reste:{this.space(state.resteInput[res.id])} €</span>}
                                                    { state.resteInput[res.id] <= 0 && <span style={{ color: "green" }}>Reste:{this.space(state.resteInput[res.id])} €</span>}
                                                </p>
                                                {state.inputSubItem.indexOf(res.id) !== -1 ? <FontAwesomeIcon icon="caret-down" className="arrowIcon" onClick={() => this.subItemsShow(res.id, 'close', "in")} /> :
                                                        <FontAwesomeIcon icon="caret-right" className="arrowIcon" onClick={() => this.subItemsShow(res.id, 'show', "in")} />}
                                                </div>
                                                {state.inputSubItem.indexOf(res.id) !== -1 && res.services.map((r,I) => <div className='subItem' key={I}>
                                                    <td className='noBoder'>-{r.label}:</td>
                                                    <td className='noBoder'>
                                                        <input className='inputmargin' value={this.inputss(state.subInput[res.id] ? state.subInput[res.id][r.id] ? state.subInput[res.id][r.id] :'':'')} onChange={(e) => this.claculateSubInput(e, res.id, r.id,r.label)} />
                                                    </td>
                                                </div>)}
                                            </div>)}
                                    </td>
                                    <td className='sidewidth'>
                                        <b>Repartition des efforts:</b><br />
                                        <span style={state.resteParentOutput > 0 ? { color: "red" } : { color: "green" }}>Reste:{`${this.space(state.resteParentOutput)} €`}</span><br />
                                        {state.subErrorOut  && <span style={{ color: "red" }}>{state.subErrorOut}</span>}
                                        {state.errorOutput  && <span style={{ color: "red" }}>{state.errorOutput}</span>}
                                        {approches.map((res, i) =>
                                            <div className='objectifi' key={i}>
                                                <div className='inline'>
                                                    <b style={{width:'9rem'}}>{res.name}:</b>
                                                <input className='inputmargin' value={this.inputss(this.state.ObjectifOutput[res.id])} name={res.id} onChange={(e) => this.claculateServiceOutput(e)} />
                                                <p style={{width:'10rem'}}>
                                                    {state.resteOutput[res.id] > 0 && <span style={{ color: "red" }}>Reste:{this.space(state.resteOutput[res.id])} €</span>}
                                                    {state.resteOutput[res.id] <= 0 && <span style={{ color: "green" }}>Reste:{this.space(state.resteOutput[res.id])} €</span>}
                                                </p>
                                                {state.outputSubItem.indexOf(res.id) !== -1 ? <FontAwesomeIcon icon="caret-down" className="arrowIcon" onClick={() => this.subItemsShow(res.id, 'close', "out")} /> :
                                                        <FontAwesomeIcon icon="caret-right" className="arrowIcon" onClick={() => this.subItemsShow(res.id, 'show', "out")} />}
                                                </div>
                                                {state.outputSubItem.indexOf(res.id) !== -1 && res.services.map((r,I) => <div className='subItem' key={I}>
                                                    <td className='noBoder'>-{r.label}:</td>
                                                    <td className='noBoder'>
                                                        <input className='inputmargin' value={this.inputss(state.subOutput[res.id] ? state.subOutput[res.id][r.id] ? state.subOutput[res.id][r.id] :'':'')} onChange={(e) => this.claculateSubOutput(e, res.id, r.id, r.label)} />
                                                    </td>
                                                </div>)}
                                            </div>)}
                                    </td>
                                </tr>}
                        </tbody>
                    </table>]}
                    {approches.length <=0  && state.objectifInput && state.objectifOutput && parseInt(state.objectifInput) > 0 && parseInt(state.objectifOutput) > 0 &&
                            <p className='paraMargin'>Veuillez créer vos approches politiques pour utiliser cette fonctionnalité depuis le dashboard de votre collectivité</p>}
                {state.resteParentInput == 0 && state.resteParentOutput == 0 && this.showbutton() &&
                <div className='buttonContainer'> 
                    <button className='buttonss' onClick={()=>this.saveData(state,scenarioId)}>{props.loadingSavingScenaro ?"....Valider l'approche politique":"Valider l'approche politique"}</button>
                </div>}
            </div>
        )
    }

    /*Saving data on submitt */
    private saveData(state,scenarioId) {
        if(state.error || state.errorOutput || state.subErrorIn || state.subErrorOut || state.objectifOutputError
        || state.objectifInputError) return
        let politicalArray = state.outputSubItem
        this.state.inputSubItem.forEach(res=>{
            if(politicalArray.includes(res && res) == false){
                politicalArray.push(res)
            }
        })
        politicalArray = [...new Set(politicalArray)];
        let data={
            arbitrage: {
              arbitragePoliticalApproaches: 
              politicalArray.map(res=> {
                    let serv=[]
                    if(state.subInput[res]){
                        serv=[...serv,...Object.keys(state.subInput[res]) ]
                    } 
                    if(state.subOutput[res]){
                        serv=[...serv,...Object.keys(state.subOutput[res])]
                    }
                    let uniqueservices = [...new Set(serv)];
                    let serviceData = []
                    uniqueservices.map(r=>{
                        let data =  {
                           service: parseInt(r),
                           recettesValue: state.subInput.hasOwnProperty(res) ? state.subInput[res][r] ? parseInt(state.subInput[res][r]):0:0,
                           depensesValue: state.subOutput.hasOwnProperty(res) ? state.subOutput[res][r] ? parseInt(state.subOutput[res][r]):0:0
                         }           
                         serviceData.push(data)
                       })          
                    let data={
                  politicalApproach: parseInt(res),
                  recettesValue: state.ObjectifInput[res] ? parseInt(state.ObjectifInput[res]) :0 ,
                  depensesValue: state.ObjectifOutput[res] ? parseInt(state.ObjectifOutput[res]):0,
                  servicePoliticalApproaches: serviceData,
                    
                }     
                return data
            })
              
            }
          }
          this.props.handleSaveData(data,scenarioId[0].id)
    }

    /*condition when submitt button will show*/
    private showbutton() {
        let inputCal = this.state.resteInput
        let outputCal = this.state.resteOutput
        let inputTotal = 0
        let outputTotal = 0
        for (const v in inputCal) {
            inputTotal = inputCal[v] ? inputCal[v] : 0 + inputTotal
        }
        for (const v in outputCal) {
            outputTotal = outputCal[v] ? outputCal[v] : 0 + outputTotal
        }
        let show = inputTotal == 0 && outputTotal == 0 ? true : false
        return show
    }

    private selectedScenario(e) {
        let value = e.target.value.toString()
        let arr = value.split(",")
        this.setState({ slected: arr[0],
            selectedID: parseInt(arr[1]),
            effortAFournirInput:0,
            effortAFournirOutput:0,
            inputSubItem: [],
            outputSubItem: [],
            resultatAnnuel: 0,
            totalDesRecettes: 0,
            totalDesDépenses: 0,
            cafBurt: 0,
            resteParentInput: null,
            resteParentOutput: null,
            ObjectifInput: {},
            ObjectifOutput: {},
            resteOutput: {},
            resteInput: {},
            objectifInput: '',
            objectifOutput: '', })
        this.props.onClickScenariosId(this.state.laID, parseInt(arr[1]), this.state.ppiID)
    }

    /*condition when submitt button will show*/ 
    private subItemsShow(res, show, side) {
        let item = this.state.inputSubItem
        let itemOut = this.state.outputSubItem
        if (show == 'show') {
            if (side == "in") {
                item.push(res)
                this.setState({ inputSubItem: item })
            } else {
                itemOut.push(res)
                this.setState({ outputSubItem: itemOut })
            }
        }
        if (show == 'close' && (item.indexOf(res) !== -1 || itemOut.indexOf(res) !== -1)) {
            if (side == "in") {
                let i = item.indexOf(res)
                item.splice(i, 1)
                this.setState({ inputSubItem: item })
            } else {
                let i = itemOut.indexOf(res)
                itemOut.splice(i, 1)
                this.setState({ outputSubItem: itemOut })
            }
        }
    }

    private onChangeObjectifInput(e) {
        let input = e.target.value.replace(/ /g,'')
        this.setState({ objectifInput: input }, () => {
            if (!this.state.objectifInputError) {
                this.objectifRecalcule()
            }
            this.calculateEffortAFournirInput(this.state.objectifInput, this.state.totalDesRecettes,'front')
        })
    }

    private objectifRecalcule() {
        let state = this.state
        let recette = state.objectifInput
        let depense = state.objectifOutput
        let id = state.selectedID
        let localAuthority = this.props.localAuthority
        let year = new Date().getFullYear()
        if (recette && depense) {
            getRecalculeScenarios(localAuthority.id, recette, depense, id, year)
                .then(res =>
                    this.setState({ recalculateResultatAnnue: res[year].resultatAnnuel, recalculateCafBrut: res[year].cafBrut })
                )
                .catch(res =>{this.props.notify(res)})
        }

    }

    private calculateEffortAFournirInput(objectifInput, recettes,coming) {
        let effort:any
        if (recettes <= objectifInput) {
             effort = parseInt(objectifInput ? objectifInput : 0) - parseInt(recettes)         
            this.setState({ effortAFournirInput: effort, resteParentInput: effort, objectifInputError: '', subInput: {}, resteInput: {} })
        } 
        if(coming == 'front' && recettes > objectifInput){
            setTimeout(() => {
                if(parseInt(this.state.objectifInput) < this.state.totalDesRecettes){
                    this.setState({ objectifInputError: 'La valeur de l’objectif ne doit pas être inférieure au total des recettes actuel', subInput: {}, resteInput: {} }) 
                }
            }, 3000);     
        }
        if(coming == 'back'){
            effort = effort ? effort : `-${recettes}`
            this.setState({ effortAFournirInput: effort, resteParentInput: effort, errorShow: false, objectifInputError: '', subInput: {}, resteInput: {} })
        }
    }

    private onChangeObjectifOutput(e) {
        let output = e.target.value.replace(/ /g,'')
        this.setState({ objectifOutput: output }, () => {
            if (!this.state.objectifOutputError) {
                this.objectifRecalcule()
            }
            this.calculateEffortAFournirOutput(this.state.objectifOutput, this.state.totalDesDépenses)
        })
    }

    private calculateEffortAFournirOutput(objectifOutput, depense) {
        if (depense >= objectifOutput) {
            let effort = parseInt(depense) - parseInt(objectifOutput ? objectifOutput : 0)
            this.setState({ effortAFournirOutput: effort, resteParentOutput: effort, objectifOutputError: '', subOutput: {}, resteOutput: {}, })
        } else {
            this.setState({objectifOutputError: 'La valeur de l’objectif ne doit pas être inférieure au total des dépenses actuel', subOutput: {}, resteOutput: {} })
        }
    }

    private claculateSubInput(e, pName, name,label) {
        let input = e.target.value.replace(/ /g,'')
        let subInput = {
            ...this.state.subInput,
            [pName]: {
                ...this.state.subInput[pName],
                [name]: input
            }
        }
        let resteInput = {
            ...this.state.resteInput,
            [pName]: this.state.ObjectifInput[pName]
        }

        this.setState({ subInput, resteInput }, () => {
            let updatedValue = 0
            let inputs = this.state.subInput
            for (const v in inputs[pName]) {
                updatedValue = updatedValue + parseInt(inputs[pName][v] ? inputs[pName][v] : 0)
            }
            let value = parseInt(this.state.resteInput[pName]) - updatedValue
            let resteInput = {
                ...this.state.resteInput,
                [pName]: value
            }
            this.setState({ resteInput, subErrorIn: '' })
            if (value < 0) {
                this.setState({ subErrorIn: ` Le montant total des services est supérieur à l’objectif de la politique ” ${label} “.` })
            }
        })
    }

    private claculateSubOutput(e, pName, name, label) {
        let output = e.target.value.replace(/ /g,'')
        let subOutput = {
            ...this.state.subOutput,
            [pName]: {
                ...this.state.subOutput[pName],
                [name]: output
            }
        }

        let resteOutput = {
            ...this.state.resteOutput,
            [pName]: this.state.ObjectifOutput[pName]
        }

        this.setState({ subOutput, resteOutput }, () => {
            let updatedValue = 0
            let output = this.state.subOutput
            for (const v in output[pName]) {
                updatedValue = updatedValue + parseInt(output[pName][v] ? output[pName][v] : 0)
            }
            let value = parseInt(this.state.resteOutput[pName]) - updatedValue
            let resteOutput = {
                ...this.state.resteOutput,
                [pName]: value
            }
            this.setState({ resteOutput, subErrorOut: '' })
            if (value < 0) {
                this.setState({  subErrorOut: ` Le montant total des services est supérieur à l’objectif de la politique ” ${label} “.` })
            }
        })
    }

    private claculateServiceInput(e) {
        let input = e.target.value.replace(/ /g,'')
        let name = e.target.name
        let ObjectifInput = {
            ...this.state.ObjectifInput,
            [name]: input
        }
        let resteInput = {
            ...this.state.resteInput,
            [name]: input
        }
        this.setState({ ObjectifInput, resteInput, resteParentInput: this.state.effortAFournirInput }, () => {
            let updatedValue = 0
            let inputs = this.state.ObjectifInput
            for (const v in inputs) {
                updatedValue = updatedValue + parseInt(inputs[v] ? inputs[v] : 0)
            }
            let lastValue = parseInt(this.state.resteParentInput.toString()) - updatedValue
            this.setState({ resteParentInput: lastValue, errorShow: false, error: '' })
            if (lastValue < 0) {
                this.setState({ errorShow: true, error: "Le montant total des politiques est supérieur à l’objectif. " })
            }
        })
    }

    private claculateServiceOutput(e) {
        let Output = e.target.value.replace(/ /g,'')
        let name = e.target.name
        let ObjectifOutput = {
            ...this.state.ObjectifOutput,
            [name]: Output
        }
        let resteOutput = {
            ...this.state.resteOutput,
            [name]: Output
        }

        this.setState({ ObjectifOutput, resteOutput, resteParentOutput: this.state.effortAFournirOutput }, () => {
            let updatedValue = 0
            let output = this.state.ObjectifOutput
            for (const v in output) {
                updatedValue = updatedValue + parseInt(output[v] ? output[v] : 0)
            }
            let lastValue = parseInt(this.state.resteParentOutput.toString()) - updatedValue
            this.setState({ resteParentOutput: lastValue, errorOutput: '' })

            if (lastValue < 0) {
                this.setState({  errorOutput: "Le montant total des politiques est supérieur à l’objectif. " })
            }
        })
    }
    private space(x) {
        if(x){
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }
        if(x == 0){
            return 0
        }      
    }
    
    private inputss(x) {
        if(x){
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }     
    }


}


interface State {
    slected: string
    objectifInput: string
    objectifOutput: string
    loading: boolean
    inputSubItem: any
    outputSubItem: any
    resultatAnnuel: Number
    totalDesRecettes: number
    totalDesDépenses: number
    cafBurt: Number
    effortAFournirInput: Number
    effortAFournirOutput: Number
    resteParentInput: Number
    resteParentOutput: Number
    ObjectifInput: any
    ObjectifOutput: any
    resteOutput: any
    resteInput: any
    ppiID: Number
    laID: Number
    localshow: boolean
    error: string
    errorOutput: string
    errorShow: boolean
    subInput: any
    subErrorIn: string
    subErrorOut: string
    subOutput: any
    selectedID: Number
    recalculateResultatAnnue: Number
    recalculateCafBrut: Number
    objectifOutputError: string
    objectifInputError: string
}

export interface Props {
    onClickScenariosId(laID: Number, id: Number, ppiID: Number): void
    handleSaveData(data:any,id:Number): void
    notify(res:any): void
    loadingScenarios: boolean
    scenarios: any
    localAuthority: any
    selectedScenarios: any
    loadingSlectedScenario: boolean
    loadingCurrentLocalAuthority: boolean
    loadingSavingScenaro: boolean
}


// WEBPACK FOOTER //
// ./src/component/policy/politique.tsx